"use client";
import { CIDADAO_STORAGE_KEY, ONBOARDING_MODAL_KEY } from "@/app/(citizen)/votacao/modals/onboarding-modal/use-onboarding-controller";
import { Icon } from "@/components/icon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LikeSolidIcon } from "@/icons";
import { deleteCookie } from "cookies-next/client";
import Link from "next/link";
import { useRouter } from "next/navigation";

type TUserMenuProps = {
  name?: string;
  href: string;
};
export function MenuDropdown({ href, name = "" }: TUserMenuProps) {
  const router = useRouter();

  function handleLogout() {
    deleteCookie("cidadao_token");
    localStorage.removeItem(CIDADAO_STORAGE_KEY);
    localStorage.removeItem(ONBOARDING_MODAL_KEY);
    router.push(href);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="z-60 flex justify-center items-center bg-background border-2 border-primary rounded-full w-10 h-10 overflow-hidden cursor-pointer">
        <Icon icon="HiUser" className="fill-secondary mt-2" size={40} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="z-50 box-border bg-muted shadow p-2 border border-card-header rounded-2xl max-w-[200px]"
        align="end"
      >
        <DropdownMenuLabel className="px-1.5 py-2 w-full text-secondary text-sm text-left">
          {name !== "" ? name : "Visitante"}
        </DropdownMenuLabel>

        <DropdownMenuItem asChild>
          <DropdownMenuItemLink href="/votacao/votos" label="Meus votos">
            <LikeSolidIcon className="fill-transparent stroke-2 stroke-secondary w-5" />
          </DropdownMenuItemLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <DropdownMenuItemLink
            href="/votacao/acompanhamentos"
            label="Acompanhar problema"
          >
            <Icon
              icon="IoNotificationsOutline"
              className="fill-transparent stroke-2 stroke-secondary w-5 h-5"
            />
          </DropdownMenuItemLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <DropdownMenuItemLink
            href="https://portal.tcu.gov.br/imprensa/noticias/tcu-lanca-portal-que-permite-participacao-ativa-da-sociedade"
            label="Ajuda"
          >
            <Icon
              icon="IoHelpCircleOutline"
              className="fill-transparent stroke-2 stroke-secondary w-5 h-5"
            />
          </DropdownMenuItemLink>
        </DropdownMenuItem>

        <DropdownMenuItem
          className="flex justify-start items-center gap-2 hover:bg-card-header px-1.5 py-2 rounded-lg focus:outline-0 hover:text-secondary! text-sm transition-all duration-200 cursor-pointer"
          onClick={handleLogout}
        >
          <span className="flex justify-start items-center w-5 h-5">
            <Icon
              icon="IoLogOutOutline"
              className="fill-transparent stroke-2 stroke-secondary w-5 h-5"
            />
          </span>
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function DropdownMenuItemLink({
  href,
  label,
  children,
}: {
  href: string;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      className="flex justify-start items-center gap-2 hover:bg-card-header px-1.5 py-2 rounded-lg focus:outline-0 text-secondary text-sm transition-all duration-200"
    >
      <span className="flex items-center w-5 h-5">{children}</span>
      {label}
    </Link>
  );
}
